module.exports = __webpack_public_path__ + "static/media/ic_arrow_next.12d53630.svg";